/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PipelineRunStatus
 */
export interface PipelineRunStatus {
    /**
     * 
     * @type {string}
     * @memberof PipelineRunStatus
     */
    runId: string | null;
    /**
     * 
     * @type {string}
     * @memberof PipelineRunStatus
     */
    status: PipelineRunStatusStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PipelineRunStatus
     */
    phase?: PipelineRunStatusPhaseEnum;
    /**
     * 
     * @type {number}
     * @memberof PipelineRunStatus
     */
    currentStep?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PipelineRunStatus
     */
    totalSteps?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PipelineRunStatus
     */
    currentStepLabel?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PipelineRunStatus
     */
    isStalled?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PipelineRunStatus
     */
    lastProgressAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof PipelineRunStatus
     */
    requestedAt?: Date | null;
}


/**
 * @export
 */
export const PipelineRunStatusStatusEnum = {
    Queued: 'QUEUED',
    NotStarted: 'NOT_STARTED',
    Managed: 'MANAGED',
    Starting: 'STARTING',
    Started: 'STARTED',
    Success: 'SUCCESS',
    Failure: 'FAILURE',
    Canceling: 'CANCELING',
    Canceled: 'CANCELED'
} as const;
export type PipelineRunStatusStatusEnum = typeof PipelineRunStatusStatusEnum[keyof typeof PipelineRunStatusStatusEnum];

/**
 * @export
 */
export const PipelineRunStatusPhaseEnum = {
    Requested: 'REQUESTED',
    Launching: 'LAUNCHING',
    Starting: 'STARTING',
    Running: 'RUNNING',
    WaitingForSensor: 'WAITING_FOR_SENSOR',
    Succeeded: 'SUCCEEDED',
    Failed: 'FAILED',
    Cancelling: 'CANCELLING',
    Cancelled: 'CANCELLED'
} as const;
export type PipelineRunStatusPhaseEnum = typeof PipelineRunStatusPhaseEnum[keyof typeof PipelineRunStatusPhaseEnum];


/**
 * Check if a given object implements the PipelineRunStatus interface.
 */
export function instanceOfPipelineRunStatus(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "runId" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function PipelineRunStatusFromJSON(json: any): PipelineRunStatus {
    return PipelineRunStatusFromJSONTyped(json, false);
}

export function PipelineRunStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PipelineRunStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'runId': json['run_id'],
        'status': json['status'],
        'phase': !exists(json, 'phase') ? undefined : json['phase'],
        'currentStep': !exists(json, 'current_step') ? undefined : json['current_step'],
        'totalSteps': !exists(json, 'total_steps') ? undefined : json['total_steps'],
        'currentStepLabel': !exists(json, 'current_step_label') ? undefined : json['current_step_label'],
        'isStalled': !exists(json, 'is_stalled') ? undefined : json['is_stalled'],
        'lastProgressAt': !exists(json, 'last_progress_at') ? undefined : (json['last_progress_at'] === null ? null : new Date(json['last_progress_at'])),
        'requestedAt': !exists(json, 'requested_at') ? undefined : (json['requested_at'] === null ? null : new Date(json['requested_at'])),
    };
}

export function PipelineRunStatusToJSON(value?: PipelineRunStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'run_id': value.runId,
        'status': value.status,
        'phase': value.phase,
        'current_step': value.currentStep,
        'total_steps': value.totalSteps,
        'current_step_label': value.currentStepLabel,
        'is_stalled': value.isStalled,
        'last_progress_at': value.lastProgressAt === undefined ? undefined : (value.lastProgressAt === null ? null : value.lastProgressAt.toISOString()),
        'requested_at': value.requestedAt === undefined ? undefined : (value.requestedAt === null ? null : value.requestedAt.toISOString()),
    };
}

